/**
 * Parallax Bubbles — AD-01
 *
 * position:absolute approach — bubbles scroll with content naturally.
 * JS adds a small upward drift (translateY) proportional to scroll position.
 * Scroll down → bubbles drift UP. Scroll up → bubbles drift DOWN.
 *
 * Speed is controlled by section settings (data-base-speed, data-speed-scale)
 * and per-bubble speed offsets (data-speed).
 *
 * Viewport-aware: bubbles with data-viewport="desktop" are skipped on mobile,
 * data-viewport="sp" are skipped on desktop.
 *
 * Two-layer: bubbles render in back (z-index:0) or front (z-index:3) layer.
 * JS treats all bubbles identically regardless of layer.
 */
(function () {
  'use strict';

  var section = document.querySelector('.anok-section--parallax-bubbles');
  if (!section) return;

  /* Read settings from the first container */
  var container = section.querySelector('.anok-parallax-bubbles');
  if (!container) return;

  /* Find all bubbles across both layers */
  var bubbles = section.querySelectorAll('.anok-parallax-bubbles__bubble');
  if (!bubbles.length) return;

  var isMobile = window.matchMedia('(max-width: 749px)').matches;
  var viewportH = window.innerHeight;
  var ticking = false;

  /* Read section-level speed settings */
  var baseSpeed = parseFloat(container.dataset.baseSpeed) || 5;
  var speedScale = parseFloat(container.dataset.speedScale) || 5;

  /* Normalize to a usable multiplier (settings range 1-30) */
  var speedMultiplier = baseSpeed / 10;
  var scaleMultiplier = speedScale / 10;

  /* Pre-compute per-bubble data. Filter by viewport. */
  var bubbleData = [];
  bubbles.forEach(function (bubble) {
    var vp = bubble.dataset.viewport || 'both';
    if (isMobile && vp === 'desktop') return;
    if (!isMobile && vp === 'sp') return;

    var bubbleY = parseInt(bubble.style.top, 10) || 0;
    var size = parseInt(bubble.dataset.size, 10) || 400;
    var speedOffset = parseInt(bubble.dataset.speed, 10) || 0;

    /* Base rate from size + per-bubble offset, scaled by section settings */
    var baseRate = 0.3 + (size / 1000) * 0.25 + speedOffset * 0.06;
    var speed = baseRate * speedMultiplier * scaleMultiplier;

    /* Above-fold bubbles: parallax from scrollY=0, no entry animation.
       Below-fold bubbles: slide up from +entryDist over 1/2 viewport of scroll.
       Entry starts when bubble position is 60% up the viewport (not at bottom edge). */
    var aboveFold = bubbleY < viewportH;
    var entryThreshold = Math.max(0, bubbleY - viewportH * 0.6);
    var entryDist = aboveFold ? 0 : viewportH * 0.5;

    bubbleData.push({ el: bubble, bubbleY: bubbleY, speed: speed,
      entryThreshold: entryThreshold, entryDist: entryDist });
  });

  function updateParallax() {
    var scrollY = window.scrollY;

    bubbleData.forEach(function (b) {
      if (b.speed === 0) return;

      var elapsed = Math.max(0, scrollY - b.entryThreshold);

      /* Entry phase: slide up from below over entryDist of scroll */
      var entryOffset = 0;
      if (b.entryDist > 0) {
        entryOffset = Math.max(0, b.entryDist - elapsed);
      }

      /* Parallax phase: drift up after entry completes */
      var parallaxScroll = Math.max(0, elapsed - b.entryDist);
      var offset = -parallaxScroll * b.speed + entryOffset;

      b.el.style.transform = 'translateY(' + offset + 'px)';
    });

    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }, { passive: true });

  updateParallax();
})();
